import { IResponse } from 'types';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'redux/store';

export interface AppState {
  userEmail: string;
  password: string;
  isStaySignedIn: boolean;
  isScrollScreen: boolean | null;
  pauseRunningDate: boolean;
}

const initialState: AppState = {
  userEmail: localStorage.getItem('userEmail') || '',
  password: localStorage.getItem('token2') || '',
  isStaySignedIn: Boolean(localStorage.getItem('staySignedIn')),
  isScrollScreen: null,
  pauseRunningDate: false,
};

export const counterSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setUserEmail: (state, action: PayloadAction<string>) => {
      state.userEmail = action.payload;
      localStorage.setItem('userEmail', action.payload);
    },
    setPassword: (state, action: PayloadAction<string>) => {
      state.password = action.payload;
      localStorage.setItem('token2', action.payload);
    },
    setIsStaySignedIn: (state, action: PayloadAction<boolean>) => {
      state.isStaySignedIn = action.payload;
      if (action.payload) {
        localStorage.setItem('staySignedIn', 'Yes');
      } else {
        localStorage.removeItem('staySignedIn');
      }
    },
    setIsScrollScreen: (state, action: PayloadAction<boolean>) => {
      state.isScrollScreen = action.payload;
    },
    setPauseRunningDate: (state, action: PayloadAction<boolean>) => {
      state.pauseRunningDate = action.payload;
    },
    /** No-op — rooms state removed with asset renting. */
    setRooms: (_state, _action: PayloadAction<unknown>) => {},
    /** No-op — desk search removed. */
    setSearch: (_state, _action: PayloadAction<string>) => {},
    /** No-op — desk sort removed. */
    setSort: (_state, _action: PayloadAction<string>) => {},
  },
});

export const {
  setUserEmail,
  setPassword,
  setIsStaySignedIn,
  setIsScrollScreen,
  setPauseRunningDate,
  setRooms,
  setSearch,
  setSort,
} = counterSlice.actions;

export const selectUserEmail = (state: RootState) => state.app.userEmail;
export const selectPassword = (state: RootState) => state.app.password;
export const selectIsStaySignedIn = (state: RootState) => state.app.isStaySignedIn;
export const selectIsScrollScreen = (state: RootState) => state.app.isScrollScreen;
export const selectPauseRunningDate = (state: RootState) => state.app.pauseRunningDate;
/** Always empty — desk rooms removed. */
export const selectRooms = (_state: RootState): Array<{ id: string, roomTypeId?: string }> | null => null;

export default counterSlice.reducer;

/** @deprecated Rooms API removed — returns empty success. */
export const getRooms = () => async (_dispatch: Function): Promise<IResponse> => ({
  status: 'success',
  data: [],
});
